import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  getAllInvoiceTypes,
  ourEntityList,
  saveFormstackInvoiceTemplate,
  //getFormstackDocuments,
  IInvoiceType,
  IOurEntity,
  getFormstackKey,
} from 'wisestep-api';
import {
  ControlledTextInput,
  Item,
  Label,
  WsButton,
  WsColors,
  WsRadioGroup,
  WsRadioObj,
  WsTitleBanner,
} from 'wisestep-base';

import WsCheckmarkSelect from '../../../components/WsCheckmarkSelect';
import { success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

import InvoiceFormstackKey from './InvoiceFormstackKey';

const invoiceType: WsRadioObj[] = [
  {
    label: 'Permanent Invoice',
    value: 'PERMANENT',
  },
  {
    label: 'Contractor Invoice',
    value: 'CONTRACTOR',
  },
];

interface ISelectedTemplate {
  id?: string | null;
  name?: string;
  formstackUrl?: string;
  placementType?: string;
  ourEntityIds?: string;
  invoiceTypeIds?: string;
}

const FormstackIntegration = ({
  id,
  name,
  formstackUrl,
  placementType,
  ourEntityIds,
  invoiceTypeIds,
}: ISelectedTemplate) => {
  const methods = useForm({
    defaultValues: {
      id: id,
      name: name,
      formstackUrl: formstackUrl,
      placementType: placementType,
      ourEntityIds: ourEntityIds,
      invoiceTypeIds: invoiceTypeIds,
      ourEntityNames: [],
    },
  });
  const { handleSubmit } = methods;
  const navigate = useNavigate();
  const [options, setOptions] = useState<IOurEntity[]>([]);
  const [invoiceOptions, setInvoiceOptions] = useState<IInvoiceType[]>([]);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const [formstackKeys, setFormstackKeys] = useState<{
    apiKey: string;
    secretKey: string;
  }>({ apiKey: '', secretKey: '' });
  const [openPopup, setOpenPopup] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await ourEntityList(0, 100);
      setOptions(response.data.data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    getAllInvoiceTypes().then(setInvoiceOptions);
  }, []);

  const onSubmit = async (data) => {
    data.ourEntityIds = data.ourEntityName.map((o) => o.id);
    data.invoiceTypeIds = data.invoiceTypename.map((i) => i.id);
    await saveFormstackInvoiceTemplate(data);
    // await getFormstackDocuments();
    setNotification(success('Template has been saved successfully'));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getFormstackKey();
        setFormstackKeys(res.data);
      } catch (error) {
        setOpenPopup(true);
      }
    };

    if (isEmpty(formstackKeys.apiKey)) {
      fetchData();
    }
  }, [formstackKeys]);

  return (
    <>
      <>
        <Grid container>
          <Grid xs={12} pb={2}>
            <WsTitleBanner title={'Integrate Formstack'} goBack={() => navigate('/')} />
          </Grid>

          <>
            <Grid item container ml={0} bgcolor={WsColors.White} p={4} spacing={2} gap={4}>
              <Grid item xs={12} marginTop={2} pl={0} borderRadius={1.5}>
                <FormProvider {...methods}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Item>
                      <Grid item xs={1} sx={{ marginLeft: '98vh' }}>
                        <WsButton
                          variant="outlined"
                          startIcon={<SettingsOutlinedIcon fontSize="small" />}
                          onClick={() => setOpenPopup(true)}
                        >
                          ManageKey
                        </WsButton>
                      </Grid>
                      <Grid spacing={1} marginLeft={36}>
                        <Label>Template Name</Label>
                        <ControlledTextInput
                          name="name"
                          labelText=""
                          type="text"
                          variant="outlined"
                          sx={{ width: '80vh' }}
                        />
                      </Grid>
                      <Grid mt={3} spacing={1} direction="column" marginLeft={36}>
                        <Label>Formstack merge Url</Label>
                        <ControlledTextInput
                          name="formstackUrl"
                          labelText=""
                          type=""
                          fullWidth
                          placeholder="Formstack merge Url"
                          variant="outlined"
                          sx={{ width: '80vh' }}
                        />
                      </Grid>
                      <Grid item xs={12} mt={2}>
                        <Grid item xs={12} marginLeft={38}>
                          <WsRadioGroup name="placementType" selectArray={invoiceType} row={true} />
                        </Grid>
                      </Grid>
                      <Grid item xs={6} mt={1}>
                        <Grid xs={12} marginLeft={36}>
                          <Label>Organisation Entity</Label>
                          <WsCheckmarkSelect
                            name="ourEntityName"
                            options={options}
                            getLabel={(option) => option.Name}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={6} mt={1}>
                        <Grid xs={12} marginLeft={36}>
                          <Label>Invoice Type</Label>
                          <WsCheckmarkSelect
                            name="invoiceTypename"
                            options={invoiceOptions}
                            getLabel={(option) => option.name}
                          />
                        </Grid>
                      </Grid>
                      <Stack
                        p={1}
                        mt={2}
                        columnGap={2}
                        direction="row"
                        justifyContent="flex-end"
                        marginRight="31vh"
                      >
                        <WsButton variant="contained" size="medium" type="submit">
                          cancel
                        </WsButton>
                        <WsButton variant="contained" size="medium" type="submit">
                          save
                        </WsButton>
                      </Stack>
                    </Item>
                  </form>
                </FormProvider>
              </Grid>
            </Grid>
          </>
        </Grid>
        {openPopup && (
          <Grid>
            <InvoiceFormstackKey
              apiKey={formstackKeys?.apiKey ? formstackKeys?.apiKey : ''}
              secretKey={formstackKeys?.secretKey ? formstackKeys?.secretKey : ''}
              closeDialog={() => setOpenPopup(false)}
            />
          </Grid>
        )}
      </>
    </>
  );
};
export default FormstackIntegration;
